const validate = values => {
  const errors = {};
  /*   if (!values.tumourType) { errors.tumourType = 'Required'; }
    if ((values.tumourType && values.tumourType === 'other') && !values.tumourTypeSpecified) {
      errors.tumourTypeSpecified = 'Required';
    } */

  const checkFieldIsValueSet = fieldValue => typeof fieldValue === 'string' && fieldValue !== 'false';

  if (checkFieldIsValueSet(values.highestRemainingGrade)
    && !checkFieldIsValueSet(values.primaryGrade)) {
    errors.primaryGrade = 'Required';
  }
  if (checkFieldIsValueSet(values.primaryGrade)
    && !checkFieldIsValueSet(values.highestRemainingGrade)) {
    errors.highestRemainingGrade = 'Required';
  }

  /* 
    if (!values.specifyGradeIndeterminatedReason) {
  
      if (!values.primaryGrade) { errors.primaryGrade = 'Required'; }
      if (!values.highestRemainingGrade) { errors.highestRemainingGrade = 'Required'; }
    }
  
    if (values.specifyGradeIndeterminatedReason && !values.gradeSpecified) {
      errors.gradeSpecified = 'Required';
    }
  
    if (!values.isupGrade) { errors.isupGrade = 'Required'; }
    if ((values.isupGrade && values.isupGrade === 'other') && !values.isupGradeSpecified) {
      errors.isupGradeSpecified = 'Required';
    }
  
    if (!values.specifyGleasonPatternPercentage && !values.percentageGleasonPattern) {
      errors.percentageGleasonPattern = 'Required';
    } 
  
    if (!values.perineuralInvasion) { errors.perineuralInvasion = 'Required'; }
    */

  //if (!values.tumourExtent1) { errors.tumourExtent1 = 'Required'; }


  if (values.tumourExtent1) {
    if (!values.tumourExtent2 && !values.tumourExtent3) {
      errors.tumourExtent2 = 'Required (one of them)';
      errors.tumourExtent3 = 'Required (one of them)';
    }

  }

  /*   if (!values.seminalDuctInvasion) { errors.seminalDuctInvasion = 'Required'; }
    if (!values.lymphovascularInvasion) { errors.lymphovascularInvasion = 'Required'; }
    if (!values.epe) { errors.epe = 'Required'; }
  
    if (values.epe === 'present' && values.specifyEpeLocation && !values.epeLocationSpecified) {
      errors.epeLocationSpecified = 'Required';
    }
  
    if (!values.intraductalCarcinoma) { errors.intraductalCarcinoma = 'Required'; }
    if (!values.coexistentPathology) { errors.coexistentPathology = 'Required'; }
    if ((values.coexistentPathology && values.coexistentPathology === 'present') && !values.coexistentPathologySpecified) {
      errors.coexistentPathologySpecified = 'Required';
    }
   */
  if (!values.termsAgreement) {
    errors.termsAgreement = 'Required';
  }

  // *********** FORM PART ONE ************** //

  if (!values.firstName) {
    errors.firstName = 'Required';
  }


  return errors;
};

export default validate;
